import { render } from "./FeaturedTyres.vue?vue&type=template&id=7c847133&scoped=true"
import script from "./FeaturedTyres.vue?vue&type=script&lang=js"
export * from "./FeaturedTyres.vue?vue&type=script&lang=js"

import "./FeaturedTyres.vue?vue&type=style&index=0&id=7c847133&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c847133"]])

export default __exports__